import { useTranslation } from 'react-i18next';
import React, { useMemo } from 'react';
import cx from 'clsx';

import { CommonModal } from '@/components/Modal/CommonModal';
import { useSwitch } from '@/hooks';
import { NftToken } from '@/views/NFT';

import { TokenWithAmountProposal, TokenWithAmount } from './TokenWithAmount';
import { ChangeToken } from './types';
import style from './index.module.scss';

type ChangeTokensProps = {
  sends: ChangeToken[];
  receives: ChangeToken[];
  tokenDict: Record<string, Tokens>;
  onTokenClick?(args: { id: string; name: string; chain: string; uuid: string }): void;
  onNftRefresh?: (data?: NftToken) => void;
  className?: string;
  // 如果为 0 / undefined 代表全显示
  maxDisplayCount?: number;
  // 用于 proposal 提交
  time?: number;
  hidePrice?: boolean;
  // 用于历史 分析模式，拼 id
  chain?: string;
  withFlag?: boolean;
  flagOffset?: number;
};

export const ChangeTokenList = ({
  sends,
  receives,
  tokenDict,
  onTokenClick,
  className,
  onNftRefresh,
  maxDisplayCount = 5,
  time,
  hidePrice,
  chain = '',
  flagOffset,
  withFlag,
}: ChangeTokensProps) => {
  const { t } = useTranslation();

  const { on, turnOff, turnOn } = useSwitch();

  const allChanges = useMemo(() => {
    const _sends = sends.map(i => ({ ...i, _amountSymbol: '-' }));
    const _receives = receives.map(i => ({ ...i, _amountSymbol: '+' }));

    return [..._sends, ..._receives];
  }, [sends, receives]);

  const displayChanges = useMemo(() => {
    return maxDisplayCount ? allChanges.slice(0, maxDisplayCount) : allChanges;
  }, [allChanges, maxDisplayCount]);

  const TokenChange = withFlag ? TokenWithAmountProposal : TokenWithAmount;

  return (
    <div className={cx('dbChangeTokenList', !displayChanges?.length && style.emptyList, className)}>
      {displayChanges?.length ? (
        <div className={style.tokenChangeWrap}>
          {displayChanges?.map((x, i) => (
            <TokenChange
              id={x.token_id}
              key={`${chain}_token:${x.token_id}`}
              token={tokenDict?.[x.token_id] || tokenDict?.[`${chain}_token:${x.token_id}`]}
              amount={x.amount}
              changeType={x._amountSymbol}
              onTokenClick={onTokenClick}
              onNftRefresh={onNftRefresh}
              time={time}
              price={x.price}
              hidePrice={hidePrice}
              className={i ? style.withSpace : undefined}
              flagOffset={flagOffset}
            />
          ))}
          {maxDisplayCount && allChanges?.length > maxDisplayCount ? (
            <div className={style.moreTokenChange} onClick={turnOn}>
              {t('ChangeTokenList_ChangeTokenList.n6mlaa', {
                count: allChanges?.length - maxDisplayCount,
              })}
            </div>
          ) : null}
        </div>
      ) : null}

      {on ? (
        <CommonModal
          on={on}
          turnOff={turnOff}
          className={style.tokenChangesModal}
          containerClassName={style.tokenChangesModalContainer}
          hideCloseBtn>
          <div className={style.tokenChangesModalContent}>
            {allChanges?.map((x, i) => (
              <TokenChange
                id={x.token_id}
                time={time}
                key={`${chain}_token:${x.token_id}`}
                amount={x.amount}
                token={tokenDict?.[x.token_id] || tokenDict?.[`${chain}_token:${x.token_id}`]}
                changeType={x._amountSymbol}
                onNftRefresh={onNftRefresh}
                onTokenClick={onTokenClick}
                price={x.price}
                hidePrice={hidePrice}
                className={i ? style.withSpace : undefined}
                flagOffset={flagOffset}
              />
            ))}
          </div>
        </CommonModal>
      ) : null}
    </div>
  );
};
